import React from "react";
// import tw from "twin.macro";
// import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import FAQ from "components/faqs/SingleCol.js";
import customerSupportIllustrationSrc from "images/customer-support-illustration.svg";
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
export default () => {

  const { therapyType } = useParams();

  useEffect(() => {
    const element = document.getElementById(therapyType);
    console.log(element,therapyType)
    if (therapyType===undefined){
      window.scrollTo(0, 0);
      return;
        }
     if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [therapyType]);

  return (  <>

      <Header />
      <FAQ
      imageSrc={customerSupportIllustrationSrc}
      imageContain={true}
      imageShadow={false}
      subheading="FAQs"
      heading={
        <>
          Heeft u <span tw="text-primary-500">vragen ?</span>
        </>
      }
    />
      <Footer />
      </>
 );
};
